import { useParams } from 'react-router-dom';

import { ChartDetailContainer } from '@/features/(charts)/chart-detail/ui/chart-detail-container';

type Props = {};

const ChartDetailPage = (props: Props) => {
  const { chart_alias } = useParams();
  if (!chart_alias) throw new Error('Cannot find chart alias');
  return <ChartDetailContainer chart_alias={chart_alias} />;
};

export default ChartDetailPage;
